import {
    ConnectionProvider,
    IntegrationConnection,
    IntegrationConnectionBase,
} from "../../types/integrationConnection";
import { IntegrationAccountDto } from "../financialAccount/integration-account.dto";
import { UserDto } from "../user/user.dto";

/**
 * Input type for IntegrationConnectionDto constructor.
 * Accepts Base type from entity classes - relations validated at runtime.
 */
export type IntegrationConnectionDtoInput = IntegrationConnectionBase;

export class IntegrationConnectionDto {
    id: string;
    provider: ConnectionProvider;
    providerId: string | null;
    label: string | null;
    workspaceId: string | null;
    createdByUserId: number | null;
    createdAt: string;
    institutionLogoUrl: string | null;
    institutionName: string | null;
    metadata: any;
    error: string | null;
    integrationAccounts?: IntegrationAccountDto[];
    createdByUser?: UserDto | null;
    entityId: number | null;
    counterpartiesSyncedAt: string | null;
    classesSyncedAt: string | null;

    constructor(connection: IntegrationConnectionDtoInput) {
        this.id = connection.id;
        this.provider = connection.provider;
        this.providerId = connection.providerId;
        this.label = connection.label;
        this.workspaceId = connection.workspaceId;
        this.createdByUserId = connection.createdByUserId;
        this.createdAt = connection.createdAt.toISOString();
        this.institutionLogoUrl = connection.institutionLogoUrl;
        this.institutionName = connection.institutionName;
        this.metadata = connection.metadata;
        this.error = connection.error;
        this.entityId = connection.entityId;
        this.counterpartiesSyncedAt =
            connection.counterpartiesSyncedAt?.toISOString() ?? null;
        this.classesSyncedAt =
            connection.classesSyncedAt?.toISOString() ?? null;
        this.integrationAccounts = connection.integrationAccounts?.map(
            (account) => new IntegrationAccountDto(account),
        );
        this.createdByUser = connection.createdByUser
            ? new UserDto(connection.createdByUser)
            : null;
    }

    static deserialize(dto: IntegrationConnectionDto): IntegrationConnection {
        return {
            ...dto,
            createdAt: new Date(dto.createdAt),
            counterpartiesSyncedAt: dto.counterpartiesSyncedAt
                ? new Date(dto.counterpartiesSyncedAt)
                : null,
            classesSyncedAt: dto.classesSyncedAt
                ? new Date(dto.classesSyncedAt)
                : null,
            integrationAccounts: dto.integrationAccounts?.map((account) =>
                IntegrationAccountDto.deserialize(account),
            ),
            createdByUser:
                dto.createdByUser && UserDto.deserialize(dto.createdByUser),
        };
    }
}
